import { useEffect } from 'react'
import { META_PIXEL_ID } from './constants'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

// Initializes the Meta Pixel and fires a single PageView event.
export function useMetaPixel(): void {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView')
      return
    }

    /*
     * The standard Meta snippet inserts before the first script tag. This
     * preview can have no script tags at this point, so append to <head>
     * instead and never depend on a sibling node existing.
     */
    const queuedCalls: unknown[][] = []
    const fbq = ((...args: unknown[]) => {
      queuedCalls.push(args)
    }) as typeof window.fbq & {
      queue: unknown[][]
      loaded: boolean
      version: string
      push: typeof window.fbq
    }

    fbq.queue = queuedCalls
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.push = fbq
    window.fbq = fbq
    window._fbq = fbq

    if (!document.getElementById('meta-pixel-script')) {
      const script = document.createElement('script')
      script.id = 'meta-pixel-script'
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      ;(document.head ?? document.documentElement).appendChild(script)
    }

    window.fbq('init', META_PIXEL_ID)
    window.fbq('track', 'PageView')
  }, [])
}
